'use client'

import { useState, useEffect } from 'react'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { getDevicePlatform } from '@utils/segmentProperties'
import { CONTACT_US_EVENTS } from '@configs/contactus.config'
import BotAnimation from './BotAnimation'
import BotBubble from './BotBubble'
import CTASubtextGroup from '../CTA/CTASubtextGroup'
import { botChannelProps } from './types'
import styles from './BotChannel.module.scss'

const ANIMATION_LOOPING_INTERVAL = 30000 // 30 sec
// Position mapping for the 4 FAQ bubbles
const bubblePositions: Array<'top-left' | 'bottom-left' | 'top-right' | 'bottom-right'> = [
  'top-right',
  'bottom-left',
  'top-left',
  'bottom-right',
]

const BotChannel = ({ isMobile, triggerCopilot, ...props }) => {
  const { title, ctaBtnText, ctaBtnSubtext, botFaqs } = props?.bot_channel?.data?.attributes as botChannelProps

  // State to track current FAQ group index
  const [currentFaqIndex, setCurrentFaqIndex] = useState(0)

  const openChat = (msg: any = '') => {
    if (triggerCopilot) {
      triggerCopilot(msg)
    }
  }

  // Rotate FAQ groups every 1 minute
  useEffect(() => {
    if (!botFaqs || botFaqs.length === 0) return

    const interval = setInterval(() => {
      setCurrentFaqIndex(prevIndex => (prevIndex + 1) % botFaqs.length)
    }, ANIMATION_LOOPING_INTERVAL)

    return () => clearInterval(interval)
  }, [botFaqs])
  const handleCtaClick = async (msg: string = '') => {
    openChat(msg)
    const event = msg.length ? CONTACT_US_EVENTS.PREFILL_QUESTIONS_CLICKED : CONTACT_US_EVENTS.CHAT_NOW_SUPPORT_CLICKED

    await trackEvent(event.eventName, {
      ...event.eventProps,
      cta_text: msg,
      platform: getDevicePlatform(),
    })
  }
  return (
    <div className={isMobile ? styles.mobile : styles.desktop}>
      <div className={styles.botChannelContainer}>
        {/* Left side - Bot Animation with FAQ Bubbles */}
        <div className={styles.botSection}>
          <div className={styles.botAnimationWrapper}>
            <BotAnimation
              // eslint-disable-next-line @typescript-eslint/no-misused-promises
              onCtaClick={handleCtaClick}
            />
            {!!botFaqs?.[currentFaqIndex] &&
              botFaqs[currentFaqIndex].slice(0, isMobile ? 2 : 4).map((faq, index) => (
                <BotBubble
                  key={index}
                  text={faq || ''}
                  position={bubblePositions[index]}
                  // eslint-disable-next-line @typescript-eslint/no-misused-promises
                  onCtaClick={handleCtaClick}
                />
              ))}
          </div>
        </div>

        {/* Right side - CTA Section */}
        <div className={styles.ctaSection}>
          <h2 className={styles.title}>{title}</h2>
          <div className={styles.ctaContent}>
            <button
              className={styles.ctaButton}
              // eslint-disable-next-line @typescript-eslint/no-misused-promises
              onClick={() => handleCtaClick()}
              type="button">
              {ctaBtnText}
            </button>
            <CTASubtextGroup subtexts={ctaBtnSubtext} isMobile={isMobile} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default BotChannel
